import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addDisbursementsApi,
  disbursementApproval,
  editDisbursementsApi,
  getDisbursementsListApi,
  getSharedDisbursementsListApi,
  getSingleDisbursementApi,
} from "@/apis/disbursementsApi";

import type {
  AddDisbursementPayloadType,
  ApprovalPayloadType,
  EditDisbursementPayloadType,
  GetDisbursementPayloadType,
  SingleDisbursementPayloadType,
} from "@/commonTypes/disbursementsTypes";

export const getDisbursementsListAction = createAsyncThunk(
  "disbursementModule/getDisbursementsList",
  async (data: GetDisbursementPayloadType) => {
    const response = await getDisbursementsListApi(data);
    return response.data;
  }
);

export const getSharedDisbursementsListAction = createAsyncThunk(
  "disbursementModule/getSharedDisbursementsList",
  async (data: GetDisbursementPayloadType) => {
    const response = await getSharedDisbursementsListApi(data);
    return response.data;
  }
);

export const getSingleDisbursementAction = createAsyncThunk(
  "disbursementModule/getSingleDisbursement",
  async (data: SingleDisbursementPayloadType) => {
    const response = await getSingleDisbursementApi(data);
    return response.data;
  }
);

export const addDisbursementsAction = createAsyncThunk(
  "disbursementModule/addDisbursement",
  async (data: AddDisbursementPayloadType) => {
    const response = await addDisbursementsApi(data);
    return response.data;
  }
);

export const editDisbursementsAction = createAsyncThunk(
  "disbursementModule/editDisbursement",
  async (data: EditDisbursementPayloadType) => {
    const response = await editDisbursementsApi(data);
    return response.data;
  }
);

export const approveDisbursementAction = createAsyncThunk(
  `disbursement/approve`,
  async (data: ApprovalPayloadType) => {
    const response = await disbursementApproval(data);
    return response.data;
  }
);
